import styled from 'styled-components';

export const SpacerContainer = styled.div`
  height: ${({height}) => height};
  width: 100%;
`;
